/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

export const ROUTES = {
  // School  Admin Routes
  DASHBOARD: '/dashboard',
  MEMBERS: '/members',
  MEMBER_PROFILE: '/members/:role',
  MEMBER_PROFILE_COMBINED_TEST: '/members/:role/test_report',
  PROFILE: '/profile',
  PROFILE_INVOICE: '/profile/invoice',

  // Login/ Logout
  LOGIN: '/login',

  NOT_FOUND: '/404',
};
